export default [
  {path: '/query', component: () => import('../page/query/index')},
]



// WEBPACK FOOTER //
// ./src/router/query.js